<template>
    <div class="patients">
        <h1 class="frame-title">Patients</h1>
        <button id="fallbackFocus" class="d-none" tabindex="-1">Hidden Fallback</button>

        <div class="general-group">

            <input type="text"
                   placeholder="🔍 Recherche..."
                   class="input-item bg-white"
                   v-model="recherche"
                   @input="rechercheLive"
                   @keydown.enter="chercher" />
            <button class="btn-nouveau-patient btn-primary" @click="nouveau_patient();">+ Nouveau Patient</button>
        </div>
        <div>
            <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p> <!-- Message d'erreur -->
            <p v-if="succesMessage" class="success-message">{{ succesMessage }}</p> <!-- Message de succès -->
        </div>
        <div v-if="isLoading" class="d-flex justify-content-center align-items-center my-3">
            <div id="viewport">
                <div class="loader">
                    <div id="p1" class="point"></div>
                    <div id="p2" class="point"></div>
                    <div id="p3" class="point"></div>
                    <div id="p4" class="point"></div>
                </div>
                <p class="loading-msg">chargement</p>
            </div>
        </div>
        <div v-else>
            <div v-if="tableauPlein">
                <div class="tableau-patients">
                    <div class="table-container">
                        <table class="tableau">
                            <thead>
                                <tr class="bg-n border-bottom" id="champs-tableau">
                                    <th class="ligne">Nom<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne">Prénom<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne">Date de naissance<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne">N°Sécurité sociale<span class="chevron">&lt;&gt;</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="border-bottom" v-for="(unpatient, key) in mespatients" :key="key">
                                    <td class="ligne" :title="unpatient.Nom" @click="selectPatient(unpatient, key)">{{unpatient.Nom}}</td>
                                    <td class="ligne" :title="unpatient.Prenom" @click="selectPatient(unpatient, key)">{{unpatient.Prenom}}</td>
                                    <td class="ligne" :title="unpatient.DateNais" @click="selectPatient(unpatient, key)">{{unpatient.DateNais}}</td>
                                    <td class="ligne" :title="unpatient.SecuAssu" @click="selectPatient(unpatient, key)">{{unpatient.SecuAssu}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-else>
                <p class="tableau-vide">Aucune donnée trouvée.</p>
            </div>
        </div>

        <!--Fiche patient (Vuetify v-dialog) : v-model reactif, plein ecran sur mobile,
            corps scrollable via flex (plus de modale Bootstrap/jQuery, plus de bug de hauteur). -->
        <v-dialog v-model="modalPatientVisible" :fullscreen="estMobile" :width="estMobile ? undefined : 720">
            <v-card class="shadow-lg rounded-lg" :style="ficheCardStyle">
                        <div v-if="modifPatientLoading">

                        </div>
                        <div v-else class="modal-header" id="header_modal" style="flex:0 0 auto;">
                            <div class="left-header">
                                <button type="button" class="btn btn-secondary" id="btn_modal_header_left" @click="precedent">
                                    <span class="material-symbols-outlined" id="left_arrow">arrow_circle_left</span>
                                </button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_header_right" @click="suivant">
                                    <span class="material-symbols-outlined" id="right_arrow">arrow_circle_right</span>
                                </button>
                            </div>
                            <div class="right-header">
                                <button type="button" class="btn btn-secondary" id="btn_modal_header_FSE" data-dismiss="modal" @click="fse">+ Créer FSE</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_header_ferme" data-dismiss="modal" aria-label="Close" @click="closeModal('patient')">
                                    <span aria-hidden="true" id="croix">&times;</span>
                                </button>
                            </div>
                        </div>
                    <div class="modal-body" style="flex:1 1 auto; min-height:0; overflow-y:auto; white-space: pre-line;">
                        <div v-if="patientActuel">
                            <div v-if="modifPatientLoading">
                                <div class="loader-container">
                                    <div class="spinner-box">
                                        <div class="circle-border">
                                            <div class="circle-core"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <h3 class="modal-title">{{patientActuel.Nom}} {{patientActuel.Prenom}}</h3>
                                <p v-if="supprimeErrorMessage" class="error-message">{{ supprimeErrorMessage }}</p>
                                <p v-if="modifErrorMessage" class="error-message"> {{ modifErrorMessage }} </p>
                                <p v-if="modifSuccesMessage" class="success-message"> {{ modifSuccesMessage }} </p>
                                <div class="modal-group-info">
                                    <h5 class="second_title_modal">Assuré(e)</h5>
                                    <p v-if="nirSecondMessage" class="second-message">{{ nirSecondMessage }}</p> <!-- Message de succès -->
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p>
                                                Nom:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.NomAssure }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.NomAssure" />
                                            </p>

                                            <p>
                                                Adresse:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.AdresseAssure }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.AdresseAssure" />
                                            </p>

                                            <p>
                                                Code Postal:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CodePostalAssure }}</span>
                                                <input v-else type="text" class="form-control" @keypress="onlyDigits" v-model="patientModifie.CodePostalAssure" />
                                            </p>
                                            
                                            <p>
                                                N° d'assuré:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.SecuAssu }}</span>
                                                <input v-else type="text" class="form-control" @input="formatNumAssure('SecuAssu')" v-model="patientModifie.SecuAssu" :class="{'input-valid': nirEtCleModifieValide, 'input-invalid': !nirEtCleModifieValide}"/>
                                            </p>

                                            <p>
                                                Code régime:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CodeRegime }}</span>
                                                <input v-else type="text" class="form-control" @blur="formatRangGem('CodeRegime')" @keypress="onlyDigits" @input="nbCaracteres(2,'modif CodeRegime')" v-model="patientModifie.CodeRegime" />
                                            </p>

                                            <p>
                                                Code gestion:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CodeGestion }}</span>
                                                <input v-else type="text" class="form-control" @keypress="onlyDigits" @input="nbCaracteres(2,'modif CodeGestion')" v-model="patientModifie.CodeGestion" />
                                            </p>
                                        </div>

                                        <div class="col-md-6">
                                            <p>
                                                Prénom:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.PrenomAssure }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.PrenomAssure" />
                                            </p>

                                            <p>
                                                Ville:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.VilleAssure }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.VilleAssure" />
                                            </p>

                                            <p>
                                                Clé:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CleAssu }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.CleAssu" :class="{'input-valid': nirEtCleModifieValide, 'input-invalid': !nirEtCleModifieValide}"/>
                                            </p>

                                            <p>
                                                Caisse gestionnaire:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CaisseGest }}</span>
                                                <input v-else type="text" class="form-control" @keypress="onlyDigits" @input="nbCaracteres(3,'modif CaisseGest')" v-model="patientModifie.CaisseGest" />
                                            </p>

                                            <p>
                                                Centre gestionnaire:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CentreGest }}</span>
                                                <input v-else type="text" class="form-control" @keypress="onlyDigits" @input="nbCaracteres(4,'modif CentreGest')" v-model="patientModifie.CentreGest" />
                                            </p>

                                            <p>Choix Nir:</p>
                                            <div v-if="!modificationActive">
                                                <select v-model="selectedOptionNir" class="form-control">
                                                    <option v-for="label in optionsNir" :key="label" :value="label">
                                                        {{ label }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div v-else>
                                                <select v-model="selectedOptionNir" class="form-control">
                                                    <option v-for="label in optionsNir" :key="label" :value="label">
                                                        {{ label }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-group-info">
                                    <h5 class="second_title_modal">Complémentaire / Mutuelle</h5>
                                    <p v-if="dateErrorMessage" class="error-message">{{ dateErrorMessage }}</p>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label>
                                                <input type="checkbox" v-if="!modificationActive" name="monChoix" v-model="mutuelle" disabled>
                                                <input v-else type="checkbox" name="monChoix" v-model="patientModifie.DroitMutuelle">
                                                Mutuelle
                                            </label>

                                            <p>
                                                Identification:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.IdentMut }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.IdentMut" />
                                            </p>

                                            <p>
                                                Numéro AMC:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.NumAMC }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.NumAMC" />
                                            </p>

                                            <p>
                                                Domaine:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.DomaineAMC }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.DomaineAMC" />
                                            </p>

                                            <div class="meme_ligne">
                                                <p>
                                                    Routage:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.RoutageAMC }}</span>
                                                    <input v-else type="text" class="form-control" v-model="patientModifie.RoutageAMC" />
                                                </p>
                                                <p>
                                                    Trt:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.TraitementAMC }}</span>
                                                    <input v-else type="text" class="form-control" v-model="patientModifie.TraitementAMC" />
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="meme_ligne">
                                                <p>
                                                    Début:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.DateDebutMut }}</span>
                                                    <input v-else type="text" class="form-control" placeholder="JJ/MM/AAAA" v-date-fr v-model="patientModifie.DateDebutMut" />
                                                </p>
                                                <p>
                                                    Fin:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.DateFinMut }}</span>
                                                    <input v-else type="text" class="form-control" placeholder="JJ/MM/AAAA" v-date-fr v-model="patientModifie.DateFinMut" />
                                                </p>
                                            </div>

                                            <p>
                                                Garantie:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.GarantieMut }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.GarantieMut" />
                                            </p>

                                            <p>
                                                N°ass AMC:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.NumAssuAMC }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.NumAssuAMC" />
                                            </p>

                                            <p>
                                                N°adhérent:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.NumAdher }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.NumAdher" />
                                            </p>

                                            <div class="meme_ligne">
                                                <p>
                                                    Hote:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.HoteAMC }}</span>
                                                    <input v-else type="text" class="form-control" v-model="patientModifie.HoteAMC" />
                                                </p>
                                                <p>
                                                    Aiguillage STS:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.AiguillageSTS }}</span>
                                                    <input v-else type="text" class="form-control" v-model="patientModifie.AiguillageSTS" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-group-info">
                                    <h5 class="second_title_modal">Patient</h5>
                                    <p v-if="ajoutErrorMessage" class="error-message">{{ ajoutErrorMessage }}</p>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p>
                                                N° de Dossier:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.NumDossier }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.NumDossier" disabled>
                                            </p>
                                            <p>
                                                Nom:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.Nom }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.Nom">
                                            </p>
                                            <p>
                                                Adresse:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.Adresse }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.Adresse">
                                            </p>
                                            <p>
                                                Code Postal:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.CodePostal }}</span>
                                                <input v-else type="text" class="form-control" @keypress="onlyDigits" v-model="patientModifie.CodePostal">
                                            </p>
                                            <p>
                                                Date de naissance:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.DateNais }}</span>
                                                <input v-else type="text" class="form-control" placeholder="JJ/MM/AAAA" v-date-fr v-model="patientModifie.DateNais">
                                            </p>
                                            <p>
                                                Qualité bénef:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.QualiBenef }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.QualiBenef">
                                            </p>
                                            <p>
                                                Droits jusqu'au:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.DateFinDroit }}</span>
                                                <input v-else type="text" class="form-control" placeholder="JJ/MM/AAAA" v-date-fr v-model="patientModifie.DateFinDroit">
                                            </p>
                                            <p>Libellé Vitale:</p>
                                            <select v-if="modificationActive" v-model="patientModifie.indexLibelleVitale" class="form-control">
                                                <option v-for="(label, key) in libelleVitale" :key="key" :value="key">
                                                    {{ label }}
                                                </option>
                                            </select>
                                            <select v-else v-model="patientActuel.indexLibelleVitale" class="form-control" disabled>
                                                <option v-for="(label, key) in libelleVitale" :key="key" :value="key">
                                                    {{ label }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-6">
                                            <p>
                                                Prénom:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.Prenom }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.Prenom">
                                            </p>
                                            <p>
                                                Nom usuel:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.NomUsuel }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.NomUsuel">
                                            </p>
                                            <p>
                                                Créé le:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.DateCreation }}</span>
                                                <input v-else type="text" class="form-control" placeholder="JJ/MM/AAAA" v-date-fr v-model="patientModifie.DateCreation">
                                            </p>
                                            <p>
                                                Ville:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.Ville }}</span>
                                                <input v-else type="text" class="form-control" v-model="patientModifie.Ville">
                                            </p>
                                            <p>Lien avec l'assuré(e): </p>
                                            <div class="meme_ligne">
                                                <p>
                                                    Type Imm:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.Immatriculation }}</span>
                                                    <input v-else type="text" class="form-control" v-model="patientModifie.Immatriculation">
                                                </p>
                                                <p>
                                                    R-G:
                                                    <span class="gras" v-if="!modificationActive">{{ patientActuel.RangGem }}</span>
                                                    <input v-else type="text" class="form-control" @blur="formatRangGem('RangGem')" @input="nbCaracteres(2,'modif RangGem')"  @keypress="onlyDigits" v-model="patientModifie.RangGem">
                                                </p>
                                                <label>
                                                    <input type="checkbox" v-if="!modificationActive" v-model="referent" disabled>
                                                    <input v-else type="checkbox" v-model="patientModifie.ConventionRef">
                                                    Conv référent
                                                </label>
                                            </div>
                                            <p>
                                                100% jusqu'au:
                                                <span class="gras" v-if="!modificationActive">{{ patientActuel.DateFinPourcent }}</span>
                                                <input v-else type="text" class="form-control" placeholder="JJ/MM/AAAA" v-date-fr v-model="patientModifie.DateFinPourcent">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="modifPatientLoading">

                    </div>
                    <div v-else style="flex:0 0 auto;">
                        <div v-if="modificationActive" class="modal-footer">
                            <button type="button" class="btn btn-secondary me-auto" id="btn_modal_footer_auto" @click="modifierMode">Défaut</button>
                            <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" @click="annulerModification">Annuler</button>
                            <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="modifierPatient">Enregistrer</button>
                        </div>
                        <div v-else class="modal-footer">
                            <button type="button" class="btn btn-secondary" id="btn_modal_footer" @click="confirmationSupprimerPatient">Supprimer</button>
                            <button type="button" class="btn btn-secondary" id="btn_modal_footer" @click="modifierMode">Modifier</button>
                        </div>
                    </div>
            </v-card>
        </v-dialog>

        <!--Modal nouveauPatient-->
        <v-dialog v-model="modalNouveauPatientVisible" :fullscreen="estMobile" :width="estMobile ? undefined : 800">
            <v-card class="shadow-lg rounded-lg" :style="ficheCardStyle">
                    <div class="modal-header" id="header_modal" style="flex:0 0 auto;">
                        <h5 class="modal-title" id="nouveauPatientModalLabel">Nouveau patient</h5>
                        <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('nouveauPatient')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="flex:1 1 auto; min-height:0; overflow-y:auto; white-space: pre-line;">
                        <div v-if="nouveauPatientLoading">
                            <div class="load-wrapp">
                                <div class="load-3">
                                    <div class="line"></div>
                                    <div class="line"></div>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p v-if="ajoutErrorMessage" class="error-message">{{ ajoutErrorMessage }}</p>
                            <p v-if="ajoutSuccesMessage" class="success-message">{{ ajoutSuccesMessage }}</p>
                            <PanneauADR v-if="adrStatut || adrResultat || adrErreur || medecinIMT"
                                        :resultat="adrResultat"
                                        :statut="adrStatut"
                                        :erreur="adrErreur"
                                        :medecin-i-m-t="medecinIMT"
                                        titre="Teleservices (ADR / IMT) - creation degrade" />
                            <div class="row justify-content-center">
                                <div class="col-md-6">
                                    <div class="meme_ligne">
                                        <label class="label-patient">
                                            N° d'assuré *
                                            <input type="text" v-model="nouveauPatient.numAssu" @input="formatNumAssure('numAssu')" placeholder="1 23 45 67 891 011" class="input-field" :class="{'input-valid': nirEtCleValide, 'input-invalid': !nirEtCleValide}" />
                                        </label>

                                        <label class="label-patient">
                                            Clé *
                                            <input type="text" v-model="nouveauPatient.cle" class="input-field" @input="nbCaracteres(2,'cle')" @keypress="onlyDigits" id="cle" :class="{'input-valid': nirEtCleValide, 'input-invalid': !nirEtCleValide}" />
                                        </label>
                                    </div>

                                    <label>
                                        Date de naissance *
                                        <input type="text" v-model="nouveauPatient.date" placeholder="JJ/MM/AAAA" v-date-fr class="input-field" />
                                    </label>
                                    <div class="meme_ligne">
                                        <label>
                                            Rang Gémellaire *
                                            <input type="text" v-model="nouveauPatient.rangGem" placeholder="1" class="input-field" @input="nbCaracteres(2,'rangGem')" @blur="formatRangGem('Gem')" @keypress="onlyDigits" id="cle" />
                                        </label>

                                        <label>
                                            Code Grand Régime *
                                            <input type="text" v-model="nouveauPatient.codeRegime" placeholder="01" class="input-field" @input="nbCaracteres(2,'codeRegime')" @blur="formatRangGem('Regime')" @keypress="onlyDigits" id="cle" />
                                        </label>
                                    </div>

                                    <!-- Identite assure : NON obligatoire. Avec une CPS, le backend interroge
                                         l'ADR a la creation et complete automatiquement nom/prenom depuis l'annuaire.
                                         A saisir seulement si l'ADR est indisponible (navigateur/smartphone sans CPS). -->
                                    <div class="meme_ligne">
                                        <label>
                                            Nom de l'assuré
                                            <input type="text" v-model="nouveauPatient.nom" placeholder="Complété par ADR si CPS" class="input-field" />
                                        </label>

                                        <label>
                                            Prénom de l'assuré
                                            <input type="text" v-model="nouveauPatient.prenom" placeholder="Complété par ADR si CPS" class="input-field" />
                                        </label>
                                    </div>
                                    <p class="hint-adr">Nom / prénom facultatifs : renseignés automatiquement par l'ADR si une carte CPS est présente.</p>
                                </div>

                                <div v-if="afficherChampsSupp" class="col-md-6">

                                    <transition name="fade-slide">
                                        <div v-show="afficherChampsSupp">
                                            <!-- Champs optionnels -->

                                            <label>
                                                Nir certifié
                                                <input type="text" v-model="nouveauPatient.nir" @input="formatNumAssure('nir')" placeholder="1 23 45 67 891 011" class="input-field" :class="{'input-valid': nirEtCleCertifieValide, 'input-invalid': !nirEtCleCertifieValide}" />
                                            </label>

                                            <label>
                                                Clé nir certifié
                                                <input type="text" v-model="nouveauPatient.cleNir" class="input-field" @input="nbCaracteres(2,'cleNir')" @keypress="onlyDigits" id="cle" :class="{'input-valid': nirEtCleCertifieValide, 'input-invalid': !nirEtCleCertifieValide}" />
                                            </label>
                                            <div class="meme_ligne">
                                                <label>
                                                    Code caisse
                                                    <input type="text" v-model="nouveauPatient.codeCaisse" placeholder="000" @input="nbCaracteres(3,'codeCaisse')" class="input-field" @keypress="onlyDigits" id="code" />
                                                </label>

                                                <label>
                                                    Code centre
                                                    <input type="text" v-model="nouveauPatient.codeCentre" placeholder="0000" @input="nbCaracteres(4,'codeCentre')" class="input-field" @keypress="onlyDigits" id="code" />
                                                </label>
                                            </div>
                                            <div class="meme_ligne">
                                                <label>
                                                    Qualité bénéf.
                                                    <input type="text" v-model="nouveauPatient.qualite" placeholder="00" maxlength="2" class="input-field" @keypress="onlyDigits" />
                                                </label>

                                                <label>
                                                    Type immat. (A/B)
                                                    <input type="text" v-model="nouveauPatient.typeImmat" placeholder="A" maxlength="1" class="input-field" @input="nouveauPatient.typeImmat = (nouveauPatient.typeImmat || '').toUpperCase()" />
                                                </label>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                                

                                <!-- Bouton centré entre les deux colonnes -->
                                <div class="col-md-12 text-center my-3">
                                    <button type="button" class="btn btn-outline-primary d-inline-flex align-items-center gap-1" id="btn-ouverture"
                                            @click="afficherChampsSupp = !afficherChampsSupp">
                                        <span class="material-symbols-outlined">
                                            {{ afficherChampsSupp ? 'chevron_left' : 'chevron_right' }}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" style="flex:0 0 auto;">
                        <button type="button" class="btn btn-secondary me-auto" id="btn_modal_footer_auto" @click="completionAutomatique">Complétion automatique</button>
                        <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('nouveauPatient')">Annuler</button>
                        <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="enregistrerNouveauPatient">Enregistrer</button>
                    </div>
            </v-card>
        </v-dialog>

        <!--Modal supprimer patient-->
        <v-dialog v-model="modalSupprimerPatientVisible" persistent :width="estMobile ? '95vw' : 600">
            <v-card class="shadow-lg rounded-lg">
                    <div class="modal-header" id="header_modal">
                        <h5 class="modal-title" id="supprimerPatientModalLabel">Etes-vous sûr de vouloir supprimer ce patient : {{patientActuel.Nom}} {{patientActuel.Prenom}} ?</h5>
                        <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('supprimerPatient');">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="white-space: pre-line;">
                        <div v-if="supprimerPatientLoading">
                            <div class="load-wrapp">
                                <div class="load-3">
                                    <div class="line"></div>
                                    <div class="line"></div>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="corps-supprimer-modal">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="supprimerPatient">OUI</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('supprimerPatient');">NON</button>
                            </div> 
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" id="btn_modal_footer" data-dismiss="modal" @click="closeModal('supprimerPatient');">Annuler</button>
                    </div>
            </v-card>
        </v-dialog>

    </div>
</template>
<style scoped>
    .patients {
        padding: 20px;
        max-width: 100%;
        height: 100vh;
        background-color: rgba(223, 207, 215, 0.1);
    }

    .frame-title {
        color: rgba(17, 147, 147);
        font-weight: bold;
        text-align: left;
        margin-bottom: 20px;
    }

    /* PARAMETRES */
    .general-group {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 50px;
    }

    .btn-nouveau-patient {
        color: white;
        font-weight: bold;
        background-color: rgba(17, 147, 147);
        border: solid 1px rgba(17, 147, 147);
        border-radius: 16px;
        padding: 15px;
        padding-right: 30px;
    }

    .input-item {
        border: none;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        padding: 15px;
        width: 50%;
    }

    /* TABLEAU PATIENTS */

    .tableau-patients {
        margin-top: 15px;
    }

    #champs-tableau {
        color: darkgray;
    }

    .ligne {
        padding: 0.5rem;
    }

    .tableau {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }

        .tableau thead {
            position: sticky;
            top: 0;
            background: white;
            width: 100%;
            z-index: 10;
        }

        .tableau tbody tr:hover {
            background-color: rgba(0, 0, 0, 0.04);
            font-weight: bold;
            cursor: pointer;
        }

        .tableau thead tr th:hover {
            color: black;
            cursor: pointer;
        }

    .chevron {
        font-size: 10px;
        transform: rotate(90deg);
        display: inline-block;
        cursor: pointer;
        transition: transform 0.3s ease;
    }

        .chevron:hover {
            transform: rotate(360deg);
        }

    .table-container {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        max-height: 800px;
        overflow-x: auto;
        overflow-y: auto;
    }

        .table-container table {
            width: 100%;
            border-collapse: collapse;
        }

    .tableau-vide {
        color: black;
        font-size: 1rem;
        font-weight: bold;
        padding: 100px;
    }

    .tableau th,
    .tableau td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
    }

    /* MODAL PATIENT */

    #croix {
        padding: 0;
        margin: 0;
        color: grey;
        font-size: 60px;
    }
    #croix:hover {
        color: black;
    }

    /* Boite calee en position:fixed avec top+bottom -> hauteur DEFINIE = ecran, SANS unite
       viewport (vh/dvh) qui ne se resolvait pas de maniere fiable sur le WebView Android. */
    .modal-dialog.modal-patient {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: auto !important;
        margin: 0 !important;
        width: 50vw;
        max-width: none !important;
        transform: none;
    }

    /* Le contenu remplit la boite en se calant sur les 4 cotes (hauteur definie sans %/vh) ;
       a l'interieur, flex colonne classique : en-tete + pied fixes, corps extensible scrollable.
       !important : passe devant tout reset global (Bootstrap Reboot / Vuetify) qui ecraserait
       sinon ces proprietes malgre la specificite scoped. */
    .modal-patient .modal-content {
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        min-height: 0 !important;
        height: auto !important;
    }

    .modal-patient .modal-header {
        flex: 0 0 auto !important;
    }

    .modal-patient .modal-footer {
        flex: 0 0 auto !important;
    }

    .modal-patient .modal-body {
        flex: 1 1 auto !important;
        min-height: 0 !important;    /* indispensable : sans ca le corps ne prend pas la place restante */
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 1rem;
    }

    .loader-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }

    .modal-patient .modal-header {
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .left-header{
        display: flex;
        justify-content: start;
        gap: 20px;
    }

    .right-header {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 20px;
    }

    #patientModalLabel {
        font-weight: bold;
    }

    #btn_modal_footer {
        background-color: white;
        border: 1px solid rgba(17, 147, 147);
        color: rgba(17, 147, 147);
        font-weight: bold;
    }

        #btn_modal_footer:hover {
            background-color: rgba(17, 147, 147);
            color: white;
        }
    #btn_modal_header_ferme {
        background-color: transparent;
        border: none;
        padding: 0;
        margin: 0;
        margin-bottom: 10px;
    }

    #btn_modal_header_ferme:hover {
        box-shadow: none;
    }

    #btn_modal_header_FSE {
        background-color: rgba(17, 147, 147, 0.7);
        color: white;
        border: 1px solid rgba(17, 147, 147, 0.7);
        border-radius: 8px;
        font-weight: bold;
    }

        #btn_modal_header_FSE:hover {
            background-color: rgba(17, 147, 147);
            color: white;
        }

    #btn_modal_header_left{
        background-color: transparent;
        border: none;
        padding:0;
    }

        #btn_modal_header_left:hover {
            background-color: transparent;
            box-shadow: none;
        }

    #btn_modal_header_right {
        background-color: transparent;
        border: none;
        padding: 0;
    }

        #btn_modal_header_right:hover {
            background-color: transparent;
            box-shadow: none;
        }

        #left_arrow {
            padding: 0;
            margin: 0;
            font-size: 40px;
            color: grey;
        }

        #left_arrow:hover {
            background-color: transparent;
            box-shadow: none;
            color: black;
        }

    #right_arrow {
        padding: 0;
        margin: 0;
        font-size: 40px;
        color: grey;
    }

        #right_arrow:hover {
            background-color: transparent;
            box-shadow: none;
            color: black;
        }

    .modal-title{
        font-weight: bold;
    }

    .modal-group-info {
        background-color: #F5F5F5;
        border: none;
        border-radius: 12px;
        padding: 10px;
        margin-top: 2rem;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

    .meme_ligne{
        display: flex;
        flex-direction: row;
        gap: 10px;
    }

    .second_title_modal {
        margin-bottom: 10px;
    }

    .gras {
        font-weight: bold;
    }

    @keyframes slideInRight {
        from {
            transform: translateX(100%);
            opacity: 0;
        }

        to {
            transform: translateX(0);
            opacity: 1;
        }
    }

    .modal.fade.show .modal-dialog.modal-patient {
        animation: slideInRight 0.5s ease forwards;
    }

    .modal.fade.show .modal-dialog.modal-nouveauPatient {
        animation: slideInRight 0.5s ease forwards;
    }

    /* MODAL NOUVEAU PATIENT */

    #nouveauPatientModal .modal-header {
        background-color: rgba(17, 147, 147);
        color: white;
    }

    #btn_modal_header:hover {
        background-color: rgba(17, 147, 147);
    }

    .input-field {
        margin-left: 10px;
        border: 0.5px solid black;
        border-radius: 12px;
        max-width: 150px;
    }

    #cle {
        gap: 0;
        max-width: 40px;
        margin: 0;
    }

    #code {
        gap: 0;
        max-width: 60px;
        margin: 0;
    }

    .label-patient{
        margin-right: 0;
        padding-right:0;
    }

    .hint-adr {
        margin: 4px 0 0;
        font-size: 12px;
        color: #6b7280;
        font-style: italic;
    }

    #btn_modal_footer_fermer {
        background-color: white;
        border: 1px solid red;
        color: red;
        font-weight: bold;
    }

        #btn_modal_footer_fermer:hover {
            background-color: red;
            color: white;
        }

    #btn_modal_footer_envoyer {
        background-color: white;
        border: 1px solid green;
        color: green;
        font-weight: bold;
    }

        #btn_modal_footer_envoyer:hover {
            background-color: green;
            color: white;
        }

    #btn_modal_footer_auto {
        background-color: white;
        border: 1px solid rgba(17, 147, 147);
        color: rgba(17, 147, 147);
        font-weight: bold;
    }

        #btn_modal_footer_auto:hover {
            background-color: rgba(17, 147, 147);
            color: white;
        }

    /*    .slide-horizontal-enter-active,
        .slide-horizontal-leave-active {
            transition: all 0.4s ease;
            overflow: hidden;
            max-width: 0;
            opacity: 0;
        }

    .slide-horizontal-enter-to {
        max-width: 100%;
        opacity: 1;
    }

    .slide-horizontal-leave-to {
        max-width: 0;
        opacity: 0;
    }*/

    .fade-slide-enter-active, .fade-slide-leave-active {
        transition: opacity 0.4s ease, transform 0.4s ease;
    }

    .fade-slide-enter-from, .fade-slide-leave-to {
        opacity: 0;
        transform: translateX(20px);
    }

    .fade-slide-enter-to, .fade-slide-leave-from {
        opacity: 1;
        transform: translateX(0);
    }

    #btn-ouverture {
        background-color: white;
        color: rgba(17, 147, 147);
        font-weight: bold;
        border: 1px solid rgba(17, 147, 147);
        border-radius: 60px;
    }

    #btn-ouverture:hover {
        background-color: rgba(17, 147, 147);
        color: white;
    }

    .input-valid {
        border: 2px solid #28a745;
        color: #28a745;
    }

    .input-invalid {
        border: 2px solid #dc3545;
        color: #dc3545;
    }

    /* MODAL SUPPRIMER PATIENT */
    #supprimerPatientModal .modal-header {
        background-color: rgba(17, 147, 147);
        color: white;
    }

    #supprimerPatientModal .corps-supprimer-modal {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }

    /* MESSAGES DE REUSSITES / ECHECS */
    .error-message {
        color: red;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 5px;
    }

    .success-message {
        color: green;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 5px;
    }

    .second-message {
        color: orange;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 5px;
    }

    /* ANIMATION DE CHARGEMENT NOUVEAU PATIENT */

    .load-wrapp {
        display: flex;
        margin: 0 10px 10px 0;
        padding: 20px 20px 20px;
        border-radius: 5px;
        text-align: center;
        align-items: center;
        justify-content: center;
    }

    .line {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 15px;
        background-color: rgba(17, 147, 147);
    }

    .load-3 .line:nth-last-child(1) {
        animation: loadingC 0.6s 0.1s linear infinite;
    }

    .load-3 .line:nth-last-child(2) {
        animation: loadingC 0.6s 0.2s linear infinite;
    }

    .load-3 .line:nth-last-child(3) {
        animation: loadingC 0.6s 0.3s linear infinite;
    }

    @keyframes loadingC {
        0% {
            transform: translate(0, 0);
        }

        50% {
            transform: translate(0, 15px);
        }

        100% {
            transform: translate(0, 0);
        }
    }

    /* ANIMATION DE CHARGEMENT MODIFICATION PATIENT */

    .spinner-box {
        width: 300px;
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
    }

    .circle-border {
        width: 150px;
        height: 150px;
        padding: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: rgb(63,249,220);
        background: linear-gradient(0deg, rgba(17, 147, 147, 0.1) 33%, rgba(17, 147, 147, 1) 100%);
        animation: spin .8s linear 0s infinite;
    }

    .circle-core {
        width: 100%;
        height: 100%;
        background-color: white;
        border-radius: 50%;
    }

    @keyframes spin {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(359deg);
        }
    }

    /* ANIMATION DE CHARGEMENT TABLEAU PATIENTS */

    #viewport {
        position: relative;
        top: 0;
        left: 0;
        height: 250px;
        width: 120px;
        margin-top: 50px;
    }


    .loading-msg {
        color: rgba(17, 147, 147, .6);
        font-size: 16px;
        font-family: 'Helvetica';
        font-weight: lighter;
        text-transform: uppercase;
        text-align: center;
        position: absolute;
        top: 62%;
        width: 100%;
        animation: msg 3s infinite linear;
    }

    .loader {
        position: absolute;
        bottom: 44%;
        left: 25%;
        width: 50%;
        height: 40%;
    }

    .point {
        position: absolute;
        width: 6px;
        height: 6px;
        background: rgba(17, 147, 147);
        border-radius: 10px;
        box-shadow: 0 0 18px 4px rgba(17, 147, 147);
    }

    #p1 {
        bottom: 0px;
        left: 20%;
        animation: loading-p1 3s infinite linear;
    }

    #p2 {
        bottom: 0px;
        left: 40%;
        animation: loading-p2 2.5s infinite linear;
    }

    #p3 {
        bottom: 0px;
        left: 60%;
        animation: loading-p3 2s infinite linear;
    }

    #p4 {
        bottom: 0px;
        left: 80%;
        animation: loading-p4 5s infinite linear;
    }

    @keyframes loading-p1 {
        0% {
            transform: translate3d(0px);
        }

        25% {
            transform: perspective(500px) translate3d(15px, -100px, 0);
        }

        50% {
            transform: perspective(500px) translate3d(70px, -70px, 0);
        }

        75% {
            transform: perspective(500px) translate3d(80px, -130px, 0);
        }

        100% {
            transform: perspective(500px) translateX(0);
        }
    }

    @keyframes loading-p2 {
        0% {
            transform: translate3d(0px);
        }

        25% {
            transform: translate3d(40px, -30px, 0);
        }

        50% {
            transform: translate3d(-10px, -100px, 0);
        }

        75% {
            transform: translate3d(-10px, -130px, 0);
        }

        100% {
            transform: translateX(0);
        }
    }


    @keyframes loading-p3 {
        0% {
            transform: translate3d(0px);
        }

        25% {
            transform: translate3d(-40px, -10px, 0);
        }

        50% {
            transform: translate3d(70px, -70px, 0);
        }

        75% {
            transform: translate3d(40px, -160px, 0);
        }

        100% {
            transform: translateX(0);
        }
    }


    @keyframes loading-p4 {
        0% {
            transform: translate3d(0px);
        }

        25% {
            transform: translate3d(-60px, -50px, 0);
        }

        50% {
            transform: translate3d(-140px, -20px, 0);
        }

        75% {
            transform: translate3d(-50px, -130px, 0);
        }

        100% {
            transform: translateX(0);
        }
    }


    @keyframes msg {
        50% {
            opacity: .3;
        }

        100% {
            opacity: 1;
        }
    }

    @media (max-width: 768px) {
        .left-header {
            gap: 10px;
        }

        .right-header {
            gap: 10px;
        }

        /* Barre d'actions du haut : recherche + bouton empiles, pleine largeur */
        .general-group {
            gap: 12px;
        }

        .input-item {
            width: 100%;
        }

        .btn-nouveau-patient {
            width: 100%;
            padding-right: 15px;
        }

        /* Fiche patient : pleine largeur sur telephone (au lieu de 50vw) */
        .modal-dialog.modal-patient {
            width: 100vw;
        }

        /* En-tete de la fiche : les boutons peuvent passer a la ligne */
        .modal-patient .modal-header {
            flex-wrap: wrap;
            gap: 10px;
        }

        /* Les paires de champs cote a cote s'empilent si trop etroit */
        .meme_ligne {
            flex-wrap: wrap;
        }
    }

</style>

<script>
    import { defineComponent } from 'vue';
    import Patient from '../script/Patient';
    import Fse from '../script/Fse';
    import Values from "../script/Values";
    import config from '../config';
    import Client from "../script/Client";
    import RequestManager from "../script/request";
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    //import Grid from './GridBase.vue';
    import PanneauADR from './PanneauADR.vue';
    import { estDateFrValide } from '../script/dateFr.js';
    export default defineComponent({
        components: { PanneauADR },
        //components: {
        //    Grid
        //},

        //data: function () {
        //    let d = {
        //        libellés: ['Option 1', 'Option 2', 'Option 3'],
        //        selectedLibellé: '',
        //        lesNirFictif: ['Option 1', 'Option 2', 'Option 3'],
        //        selectedNirFictif: '',
        //        lesCles: ["DateNaissance", "Nom", "Prenom"],
        //        cleDeTrie: 'Nom',
        //        lesPatients: [],
        //        patientCourant: {},
        //        assure: {},
        //        critereRecherchePatientTransCam: "",
        //    }
        //    var ordreTri = {};
        //    d.lesCles.forEach(function (uneCle) {
        //        ordreTri[uneCle] = 1;
        //    });

        //    d['ordreTri'] = ordreTri;
        //    return d;
        //},

        data() {
            return {
                claims: { email: "" },
                contrat: {
                    RPPS: "",
                    ADELI: "",
                    nom: "",
                    prenom: "",
                    tel: "",
                    email: ""
                },
                nouveauPatient: {
                    numAssu: "",
                    cle: "",
                    nirCertifie: "",
                    cleNirCertifie: "",
                    date: "",
                    rangGem: "",
                    codeCaisse: "",
                    codeCentre: "",
                    codeRegime: "",
                    // Identite assure : obligatoire en degrade sans carte/CPS (le backend exige
                    // nom/prenom/qualite/typeImmat pour valider le patient, cf controle_saisie_patient).
                    nom: "",
                    prenom: "",
                    qualite: "00",
                    typeImmat: "A"
                },
                optionsNir: ["Nir Fictif", "Contraception", "IVG", "Vaccin Covid"],
                selectedOptionNir: 'Nir Fictif',
                numNirOriginal: "",
                cleNirOriginal: "",
                modalPatientVisible: false,
                modalNouveauPatientVisible: false,
                modalSupprimerPatientVisible: false,
                mespatients: {},
                recherche: "",
                rechercheTimer: null,
                patientActuel: {},
                patientModifie: {},
                currentKey: "",
                keys: [],
                libelleVitale: {},
                succesMessage: "",
                errorMessage: "",
                nirSecondMessage: "",
                ajoutErrorMessage: "",
                ajoutSuccesMessage: "",
                // Etat ADR degrade (lance backend a la creation patient) pour le panneau ADR depliable.
                adrResultat: "",
                adrStatut: "",
                adrErreur: "",
                supprimeErrorMessage: "",
                tableauPlein: false,
                isLoading: false,
                mutuelle: false,
                referent: false,
                afficherChampsSupp: false,
                infosCarteVitale: {},
                nouveauPatientLoading: false,
                supprimerPatientLoading: false,
                modificationActive: false,
                modifErrorMessage: "",
                modifSuccesMessage: "",
                modifPatientLoading: false,
                dateErrorMessage: "",
                nirEtCleValide: false,
                nirEtCleCertifieValide: false,
                nirEtCleModifieValide: false
            };
        },
        watch: {
            selectedOptionNir(newValue) {
                this.getNewNir(newValue);
            },
            'nouveauPatient.numAssu': function (newVal) {
                this.verifieNirEtCle();
            },
            'nouveauPatient.cle': function (newVal) {
                this.verifieNirEtCle();
            },
            'nouveauPatient.nir': function (newVal) {
                this.verifieNirEtCleCertifie();
            },
            'nouveauPatient.cleNir': function (newVal) {
                this.verifieNirEtCleCertifie();
            },
            'patientModifie.SecuAssu': function (newVal) {
                this.verifieNirEtCleModifie();
            },
            'patientModifie.CleAssu': function (newVal) {
                this.verifieNirEtCleModifie();
            }
        },
        computed: {
            // Vrai sur mobile (WebView) -> v-dialog plein ecran.
            estMobile() {
                return RequestManager.estMobile;
            },
            // Style de la v-card de fiche : plein ecran (mobile) = hauteur 100%, sinon plafonnee a
            // 90vh. Dans les deux cas flex colonne + le corps (.modal-body) scrolle. Aucune unite
            // viewport posee sur un enfant : la hauteur vient de la v-dialog Vuetify (fiable).
            ficheCardStyle() {
                return this.estMobile
                    ? 'display:flex; flex-direction:column; height:100%;'
                    : 'display:flex; flex-direction:column; max-height:90vh;';
            },
            // Resultat IMT (medecin traitant) du store, pour l'afficher dans le panneau ADR/IMT.
            medecinIMT() {
                return this.$store.getters['ChoixBenecStore/getMedecinIMT'];
            },
        },
        lesPatientsTries: function () {
            return this.sortBy();
        },

        methods: {
            verifieNirEtCle() {
                const nir = this.nouveauPatient.numAssu;
                const cle = this.nouveauPatient.cle;
                this.nirEtCleValide = this.isNirEtCleValide(nir, cle);
                //console.log("je suis passé : ", this.nirEtCleValide);
            },
            verifieNirEtCleCertifie() {
                const nir = this.nouveauPatient.nir;
                const cle = this.nouveauPatient.cleNir;
                this.nirEtCleCertifieValide = this.isNirEtCleValide(nir, cle);
            },
            verifieNirEtCleModifie() {
                const nir = this.patientModifie.SecuAssu;
                const cle = this.patientModifie.CleAssu;
                this.nirEtCleModifieValide = this.isNirEtCleValide(nir, cle);
            },
            carteVitale() {
                return this.$store.getters["SSV/getCarteVitale"];
            },
            enumCarteVitale() {
                return this.$store.getters["SSV/getStructures_publiques_cartevitale"];
            },
            // Recherche "live" : lancee a la frappe (sans Entree), avec un debounce de 350 ms
            // pour ne pas appeler le backend a chaque caractere. < 2 caracteres -> on vide la
            // liste sans requete (le backend borne deja a TOP 50). Branche sur @input (et NON
            // sur un watch de `recherche`) pour ne PAS se declencher quand `recherche` est
            // modifiee par le code (ex. modifierPatient), ce qui clôturerait la fiche ouverte.
            rechercheLive(e) {
                clearTimeout(this.rechercheTimer);
                const terme = ((e && e.target && e.target.value) || '').trim();
                if (terme.length < 2) {
                    this.mespatients = {};
                    this.keys = [];
                    this.tableauPlein = false;
                    this.isLoading = false;
                    this.errorMessage = "";
                    this.succesMessage = "";
                    return;
                }
                this.rechercheTimer = setTimeout(() => { this.chercher(); }, 350);
            },
            async chercher() {
                this.succesMessage = "";
                this.errorMessage = "";
                this.patientActuel = {};
                this.mespatients = {};
                this.keys = [];
                this.tableauPlein = false;
                this.isLoading = true;
                try {
                    if (this.recherche == "" || this.recherche == null || this.recherche == undefined) {
                        this.errorMessage = "Veuillez saisir une recherche.";
                        this.isLoading = false;
                    } else {
                        let response = await Patient.getPatientBySearch(this.recherche);
                        //console.log("Réponse de la recherche des patients : ", response);
                        //this.selectPatient(response, 0); // Sélectionne le premier patient trouvé
                        //this.$router.push({ path: '/transcam/Patient', query: { setPatient: response } });
                        this.mespatients = response.Patients;
                        this.libelleVitale = response.ListLibelleVitale;
                        console.log("liste des libellés vitale : ", this.libelleVitale);
                        //console.log("Liste des patients : ", this.mespatients);
                        let longueur_tableau = Object.keys(this.mespatients).length;
                        if (longueur_tableau == 0) {
                            console.log("je passe par la");
                            this.tableauPlein = false;
                            this.succesMessage = "Pas de patient trouvé";
                            this.isLoading = false;
                        } else {
                            this.tableauPlein = true;
                            this.keys = Object.keys(this.mespatients);
                            //this.succesMessage = "Données des patients récupérées avec succès !";
                            this.isLoading = false;
                        }
                        console.log("Résultats de la recherche des patients : ", this.mespatients);
                    }
                } catch (error) {
                    console.error("Erreur lors de la récupération des patients : ", error);
                    this.isLoading = false;
                    this.errorMessage = "Erreur lors de la récupération des données des patients."
                }
                
            },
            async getNewNir(newValue) {
                if (newValue == "Nir Fictif") {
                    if (!this.modificationActive) {
                        this.patientActuel.SecuAssu = this.numNirOriginal;
                        this.patientActuel.CleAssu = this.cleNirOriginal;
                    } else {
                        this.patientModifie.SecuAssu = this.numNirOriginal;
                        this.patientModifie.CleAssu = this.cleNirOriginal;
                    }
                    
                    this.nirSecondMessage = "";
                    return;
                }
                try {
                    const response = await Patient.getNewNir(newValue, this.contrat.RPPS);
                    console.log("Les nouveaux numéros Nir : ", response);
                    if (!this.modificationActive) {
                        this.patientActuel.SecuAssu = response.Item2;
                        this.patientActuel.CleAssu = response.Item1;
                    } else {
                        this.patientModifie.SecuAssu = response.Item2;
                        this.patientModifie.CleAssu = response.Item1;
                    }
                    this.nirSecondMessage = `Exemple des données NIR pour ${newValue} :`;
                } catch (error) {
                    console.log("Erreur lors de la récupération du nouveau numéro Nir et de la nouvelle clé Nir : ", error);
                }
            },
            selectPatient(patient, key) {
                this.nirSecondMessage = "";
                this.modifErrorMessage = "";
                this.modifSuccesMessage = "";
                this.ajoutErrorMessage = "";
                this.selectedOptionNir = 'Nir Fictif';
                this.patientActuel = patient;
                //console.log("Patient sélectionné");
                this.numNirOriginal = this.patientActuel.SecuAssu;
                this.cleNirOriginal = this.patientActuel.CleAssu;
                this.currentKey = key;
                console.log("Ouverture de la modal d'informations du patient : ", this.currentKey, " : ", this.patientActuel);
                this.modalPatientVisible = true;
                this.mutuelle = this.patientActuel.DroitMutuelle;
                this.referent = this.patientActuel.ConventionRef;
                // v-dialog : ouverture par v-model (modalPatientVisible = true ci-dessus).
            },
            async nouveau_patient() {
                this.modalNouveauPatientVisible = true;
                this.afficherChampsSupp = false;
                this.nouveauPatientLoading = false;
                this.ajoutErrorMessage = "";
                this.ajoutSuccesMessage = "";
                // Repartir d'un panneau ADR vierge a chaque ouverture (ne pas montrer un ancien resultat).
                this.adrResultat = "";
                this.adrStatut = "";
                this.adrErreur = "";
                this.infosCarteVitale = "";

                try {
                    //let response_vitale = await this.carteVitale();
                    //console.log("La réponse de carteVitale() : ", response_vitale);

                    //let response_enum_vitale = await this.enumCarteVitale();
                    //console.log("La résponse de enumCarteVitale() : ", response_enum_vitale);

                    //this.infosCarteVitale = await Patient.getInfosVitale();
                    //console.log("Informations de la carte vitale : ", this.infosCarteVitale);

                    //if (this.infosCarteVitale == undefined || this.infosCarteVitale == null) {
                    //    this.errorMessage = "Aucunes données vitale.";
                    //    return;
                    //}

                    //if (this.infosCarteVitale.length == 0) {
                    //    this.errorMessage = "Aucunes données vitale.";
                    //    return;
                    //}

                } catch (error) {
                    console.log("Erreur lors de la récupération des informations de la carte vitale : ", error);
                }

                this.nouveauPatient.numAssu = "";
                this.nouveauPatient.cle = "";
                this.nouveauPatient.nirCertifie = "";
                this.nouveauPatient.cleNirCertifie = "";
                this.nouveauPatient.date = "";
                this.nouveauPatient.rangGem = "01";
                this.nouveauPatient.codeCaisse = "000";
                this.nouveauPatient.codeCentre = "0000";
                this.nouveauPatient.codeRegime = "01";
                this.nouveauPatient.nom = "";
                this.nouveauPatient.prenom = "";
                this.nouveauPatient.qualite = "00";
                this.nouveauPatient.typeImmat = "A";
                // v-dialog : ouverture par v-model (modalNouveauPatientVisible = true ci-dessus).
            },
            async enregistrerNouveauPatient() {
                // Nom/prenom NON exiges cote front : avec une CPS, le backend lance l'ADR a la
                // creation et complete l'identite depuis l'annuaire. Si l'ADR echoue ET que
                // l'identite est vide, c'est le backend qui refuse (message "Nom de l'assuré
                // obligatoire") -> affiche tel quel ("(sinon oui)").
                if (this.nouveauPatient.numAssu == "" || this.nouveauPatient.cle == "" || this.nouveauPatient.date == "" || this.nouveauPatient.rangGem == "" || this.nouveauPatient.codeRegime == "") {
                    if (this.ajoutErrorMessage.length > 0) {
                        return;
                    }
                    this.ajoutErrorMessage = "Veuillez compléter les champs obligatoires *";
                    return;
                }
                if (!estDateFrValide(this.nouveauPatient.date)) {
                    this.ajoutErrorMessage = "Date de naissance invalide. Format JJ/MM/AAAA (ex. 010181 → 01/01/1981).";
                    return;
                }
                if (!this.nirEtCleValide) {
                    this.ajoutErrorMessage = "N° d'assuré et clé invalides *";
                    return;
                }

                // nir/cleNir (Nir certifié) ne sont rendus que si le panneau avancé est ouvert :
                // ils peuvent donc etre undefined -> lecture null-safe pour ne pas planter la creation.
                if ((this.nouveauPatient.nir || "").length > 0 || (this.nouveauPatient.cleNir || "").length > 0) {
                    if (!this.nirEtCleCertifieValide) {
                        this.ajoutErrorMessage = "Nir certifié et clé nir certifié invalides *";
                        return;
                    }
                }

                this.ajoutErrorMessage = "";
                this.ajoutSuccesMessage = "";

                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.nouveauPatientLoading = true;

                try {
                    let patient = [{
                        numAssu: this.nouveauPatient.numAssu,
                        cle: this.nouveauPatient.cle,
                        nirCertifie: this.nouveauPatient.nirCertifie,
                        cleNirCertifie: this.nouveauPatient.cleNirCertifie,
                        date: this.nouveauPatient.date,
                        rangGem: this.nouveauPatient.rangGem,
                        codeCaisse: this.nouveauPatient.codeCaisse,
                        codeCentre: this.nouveauPatient.codeCentre,
                        codeRegime: this.nouveauPatient.codeRegime,
                        // Identite assure (degrade sans carte) : le backend en a besoin pour valider
                        // le patient (controle_saisie_patient) sinon la FSE degradee sera refusee.
                        nom: this.nouveauPatient.nom,
                        prenom: this.nouveauPatient.prenom,
                        codeQualite: this.nouveauPatient.qualite,
                        typeImmat: this.nouveauPatient.typeImmat
                    }
                    //{
                    //    numAssu: this.infosCarteVitale[0].NIRAssure,
                    //    cle: this.infosCarteVitale[0].CleAssure,
                    //    nir: this.infosCarteVitale[0].NIR,
                    //    cleNir: this.infosCarteVitale[0].Cle,
                    //    date: this.formatDateISOToFR(this.infosCarteVitale[0].DateNaissance),
                    //    rangGem: this.infosCarteVitale[0].RangNaissance,
                    //    codeCaisse: this.infosCarteVitale[0].CodeCaisse,
                    //    codeCentre: this.infosCarteVitale[0].CodeCentre,
                    //    codeRegime: this.infosCarteVitale[0].CodeRegime,
                    //    adresse2: this.infosCarteVitale[0].Adresse2,
                    //    adresse4: this.infosCarteVitale[0].Adresse4,
                    //    adresse6: this.infosCarteVitale[0].Adresse6,
                    //    codeAld: this.infosCarteVitale[0].CodeALD,
                    //    codeGestion: this.infosCarteVitale[0].CodeGestionAssure,
                    //    codeQualite: this.infosCarteVitale[0].CodeQualite,
                    //    codeSituation: this.infosCarteVitale[0].CodeSituation,
                    //    dateDebutDroits: this.infosCarteVitale[0].DateDebutDroits,
                    //    dateFinDroits: this.infosCarteVitale[0].DateFinDroits,
                    //    dateReponse: this.infosCarteVitale[0].DateReponse,
                    //    nom: this.infosCarteVitale[0].Nom,
                    //    prenom: this.infosCarteVitale[0].Prenom
                        //}
                    ];

                    const response = await Patient.enregistrerNouveauPatient(patient);
                    await delay(2000);
                    this.nouveauPatientLoading = false;
                    // Succes backend : "OK" (ou "" / "Réussit" pour compat). Tout autre texte est un
                    // message d'erreur (validation identite, patient deja en base, echec insertion) a afficher.
                    const reponseOk = (response === "" || response === "OK" || response === "Réussit");
                    if (!reponseOk) {
                        const brut = String(response || "");
                        this.ajoutErrorMessage = (brut.indexOf("Patient") === 0 || brut.indexOf("Ce patient") === 0 || brut.indexOf("Erreur") === 0)
                            ? brut
                            : "Erreur lors de l'ajout du nouveau patient : " + brut;
                        this.ajoutSuccesMessage = "";
                    } else {
                        this.ajoutErrorMessage = "";
                        this.ajoutSuccesMessage = "Le patient a été enregistré avec succès !";
                    }
                    // Le backend interroge l'ADR a la creation (contexte CPS) : on affiche TOUJOURS
                    // son retour dans le panneau ADR depliable, y compris en cas d'echec de creation
                    // (l'erreur ADR explique alors pourquoi l'identite n'a pas pu etre completee).
                    try {
                        await this.$store.dispatch("ChoixBenecStore/fetchEtatADR");
                        this.adrResultat = this.$store.getters["ChoixBenecStore/getDonneeResponseADR"] || "";
                        this.adrStatut = this.$store.getters["ChoixBenecStore/getStatutADR"] || "";
                        this.adrErreur = this.$store.getters["ChoixBenecStore/getErreurADR"] || "";
                        // IMT (medecin traitant) en degrade : le backend l'interroge a la creation
                        // (meme identite que l'ADR), sur un thread de fond -> on poll le resultat
                        // pour que NewFSE puisse pre-remplir le medecin oriente.
                        this.$store.dispatch("ChoixBenecStore/pollReponseIMT");
                    } catch (e) {
                        console.error("Recuperation etat ADR (degrade) :", e);
                    }
                } catch (error) {
                    this.nouveauPatientLoading = false;
                    console.log("Erreur lors de l'ajout du nouveau patient : ", error)
                    this.ajoutErrorMessage = "Erreur lors de l'ajout du nouveau patient.";
                    this.ajoutSuccesMessage = "";
                }
            },
            closeModal(facture) {
                if (facture == 'patient') {
                    this.supprimeErrorMessage = "";
                    if (this.modificationActive) {
                        this.annulerModification();
                    }
                    this.patientActuel.SecuAssu = this.numNirOriginal;
                    this.patientActuel.CleAssu = this.cleNirOriginal;
                    this.modalPatientVisible = false;
                } else if (facture == 'nouveauPatient') {
                    this.modalNouveauPatientVisible = false;
                } else if (facture == 'supprimerPatient') {
                    this.modalSupprimerPatientVisible = false;
                }
                // Vuetify (v-dialog) gere focus, scroll-lock du body et accessibilite :
                // plus de manipulation aria-hidden/inert/visibility ni de bouton declencheur.
            },
            precedent() {
                let currentKey = this.currentKey;
                let currentIndex = this.keys.indexOf(currentKey);
                console.log("index courant : ", currentIndex);
                if (currentIndex > 0) {
                    this.modifErrorMessage = "";
                    this.modifSuccesMessage = "";
                    this.supprimeErrorMessage = "";
                    this.patientActuel.SecuAssu = this.numNirOriginal;
                    this.patientActuel.CleAssu = this.cleNirOriginal;
                    this.nirSecondMessage = "";
                    this.selectedOptionNir = 'Nir Fictif';
                    let prevKey = this.keys[currentIndex - 1];
                    let prevValue = this.mespatients[prevKey];
                    this.currentKey = prevKey;
                    this.patientActuel = prevValue;
                    this.mutuelle = this.patientActuel.DroitMutuelle;
                    this.referent = this.patientActuel.ConventionRef;
                    this.numNirOriginal = this.patientActuel.SecuAssu;
                    this.cleNirOriginal = this.patientActuel.CleAssu;
                }
            },
            suivant() {
                let currentKey = this.currentKey;
                let currentIndex = this.keys.indexOf(currentKey);

                if (currentIndex < this.keys.length - 1) {
                    this.modifErrorMessage = "";
                    this.modifSuccesMessage = "";
                    this.supprimeErrorMessage = "";
                    this.patientActuel.SecuAssu = this.numNirOriginal;
                    this.patientActuel.CleAssu = this.cleNirOriginal;
                    this.nirSecondMessage = "";
                    this.selectedOptionNir = 'Nir Fictif';
                    let nextKey = this.keys[currentIndex + 1];
                    let nextValue = this.mespatients[nextKey];
                    this.currentKey = nextKey;
                    this.patientActuel = nextValue;
                    this.mutuelle = this.patientActuel.DroitMutuelle;
                    this.referent = this.patientActuel.ConventionRef;
                    this.numNirOriginal = this.patientActuel.SecuAssu;
                    this.cleNirOriginal = this.patientActuel.CleAssu;
                }
            },
            confirmationSupprimerPatient() {
                this.supprimeErrorMessage = "";
                // v-dialog : s'empile au-dessus de la fiche patient (z-index Vuetify gere).
                this.modalSupprimerPatientVisible = true;
            },
            async supprimerPatient() {
                if (!this.currentKey) {
                    this.supprimeErrorMessage = "L'identifiant du patient n'est pas détecté.";
                    this.modalSupprimerPatientVisible = false;
                    return;
                }
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.supprimerPatientLoading = true;
                try {
                    let response = await Patient.supprimerPatient(this.currentKey);
                    await delay(2000);
                    if (response == "Suppression réussie") {
                        this.supprimerPatientLoading = false;
                        this.modalSupprimerPatientVisible = false;
                        this.modalPatientVisible = false;
                        await this.chercher();
                        this.succesMessage = "Le patient a été supprimé avec succès !";
                    } else {
                        this.supprimerPatientLoading = false;
                        this.supprimeErrorMessage = "Erreur lors de la suppression du patient.";
                        this.modalSupprimerPatientVisible = false;
                    }
                } catch (error) {
                    this.supprimerPatientLoading = false;
                    console.log("Erreur lors de la suppression du patient : ", error);
                    this.supprimeErrorMessage = "Erreur lors de la suppression du patient.";
                    this.modalSupprimerPatientVisible = false;
                }
            },
            modifierMode() {
                this.ajoutErrorMessage = "";
                this.modificationActive = true;
                this.patientModifie = JSON.parse(JSON.stringify(this.patientActuel));
            },
            async modifierPatient() {
                if (this.patientModifie == this.patientActuel) {
                    return;
                }

                if (!this.nirEtCleModifieValide) {
                    this.modifErrorMessage = "N° d'assuré et clé invalides *";
                    return;
                }
                //mettre des vérifications sur tous les champs importants

                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.modifPatientLoading = true;

                try {
                    this.recherche = this.patientActuel.Nom + " " + this.patientActuel.Prenom;
                    let response = await Patient.modifierPatient(this.patientModifie);
                    console.log("la réponse : ", response);
                    await delay(2000);
                    if (response.Item1 == "") {
                        this.modifPatientLoading = false;
                        this.patientActuel = response.Item2;
                        this.mespatients[this.currentKey] = response.Item2;
                        this.annulerModification();
                        this.modifSuccesMessage = "Le patient a été modifié avec succès !";
                    } else {
                        this.modifPatientLoading = false;
                        this.modifErrorMessage = "Erreur lors de la modification des données du patient : " + response.Item1;
                    }
                } catch (error) {
                    this.modifPatientLoading = false;
                    this.modifErrorMessage = "Erreur lors de la modification des données du patient : " + error;
                }
            },
            annulerModification() {
                this.ajoutErrorMessage = "";
                this.modificationActive = !this.modificationActive;
            },
            async fetchClaims() {
                const token = RequestManager.getToken();
                if (!token) {
                    console.warn("TOKEN == null");
                    return;
                }
                this.claims = await Values.GetClaims(token);
                if (this.claims?.email) {
                    await this.fetchContrat();
                } else {
                    console.error("Impossible de récupérer l'email de l'utilisateur.");
                }
            },
            async fetchContrat() {
                if (!this.claims?.email) {
                    alert("L'email de l'utilisateur est introuvable !");
                    return;
                }
                try {
                    this.contrat = await Client.getClientWithEmail(this.claims.email);
                    console.log("le contrat tiers payants :", this.contrat);
                } catch (error) {
                    console.error("Erreur lors de la récupération du contrat :", error);
                }
            },
            async fse() {
                // Mode degrade : on informe d'abord le backend du patient choisi (currentKey =
                // identifiant base) pour qu'il construise la structure VITALE degradee + benec.
                // Sans ca, l'enregistrement FSE est refuse ("Il faut au moins choisir un patient
                // Ou bien lire une carte VITALE").
                try {
                    const res = await Fse.chargerPatientDegrade(this.currentKey);
                    const ok = res && (res.success ?? res.Success);
                    if (!ok) {
                        const msg = (res && (res.message ?? res.Message))
                            || "Impossible de preparer la FSE en mode degrade pour ce patient.";
                        alert(msg);
                        return;
                    }
                } catch (e) {
                    console.error("Erreur lors de la preparation de la FSE degradee :", e);
                    alert("Erreur lors de la preparation de la FSE en mode degrade.");
                    return;
                }
                // IMT : chargerPatientDegrade a interroge le medecin traitant du patient choisi
                // (backend, thread de fond). On poll le resultat pour que NewFSE pre-remplisse le
                // medecin oriente. Fire-and-forget : le poll continue pendant/apres la navigation,
                // NewFSE (watch/mounted) applique le resultat des qu'il arrive.
                this.$store.dispatch('ChoixBenecStore/pollReponseIMT');
                // Memorise le patient selectionne pour la nouvelle FSE, puis ouvre NewFSE
                this.$store.dispatch('FSEHandler/setPatientCourant', this.patientActuel);
                this.$router.push({ name: 'NewFSE' });
            },
            setModifEnTempsReel(bool) {
                this.modifEnTempsReel = bool;
                return true;
            },
            setPatientCourant(n) {
                //this.$store.dispatch("ConnexionStore/setPatientCourant", n.Key);
                //this.$router.push({ name: this.appliLance + "RechercheID", params: { id: n.Key } });
                this.patientCourant = n;
                console.log(this.patientCourant);
                alert("Patient courant changé");
                return true;
            },
            setLesPatients(critere) {
                this.$store.dispatch("ConnexionStore/setLesPatientsBySearh", critere);
            },
            afficherPatientCourant(unPatient) {
                this.$emit('setPatientCourant', unPatient);
            },
            sortBy() {
                var uneCle = this.cleDeTrie;
                var p = this.lesPatients;
                if (p != null && Array.isArray(p)) {
                    var ordreTri = -this.ordreTri[uneCle];
                    p = p.slice().sort(function (a, b) {
                        a = a['Value'][uneCle];
                        b = b['Value'][uneCle];
                        return (a === b ? 0 : a > b ? 1 : -1) * ordreTri;
                    });
                    return p;
                }
                else
                    return [];

                //console.log(p[0].value.nom);
            },
            test() {
                console.log(this.lesPatients);
            },
            nbCaracteres(nombre, champ) {
                if (champ.startsWith("modif ")) {
                    const vraiChamp = champ.slice(6);
                    let valeur = this.patientModifie[vraiChamp];

                    if (!valeur) return;

                    valeur = valeur.replace(/\s+/g, '').toUpperCase().slice(0, nombre);
                    this.patientModifie[vraiChamp] = valeur;
                } else {
                    let valeur = this.nouveauPatient[champ];

                    if (!valeur) return;

                    valeur = valeur.replace(/\s+/g, '').toUpperCase().slice(0, nombre);
                    this.nouveauPatient[champ] = valeur;
                }
            },
            formatNumAssure(champ) {
                let nir = champ === 'SecuAssu'
                    ? this.patientModifie[champ] || ''
                    : this.nouveauPatient[champ] || '';

                nir = nir.replace(/\s+/g, '').toUpperCase().slice(0, 13);

                let formatted = '';

                if (nir.length > 0) {
                    formatted += nir.substring(0, 1);
                }
                if (nir.length > 1) {
                    formatted += ' ' + nir.substring(1, 3);
                }
                if (nir.length > 3) {
                    formatted += ' ' + nir.substring(3, 5);
                }
                if (nir.length > 5) {
                    formatted += ' ' + nir.substring(5, 7);
                }
                if (nir.length > 7) {
                    formatted += ' ' + nir.substring(7, 10);
                }
                if (nir.length > 10) {
                    formatted += ' ' + nir.substring(10, 13);
                }

                if (champ === 'SecuAssu') {
                    this.patientModifie[champ] = formatted;
                } else {
                    this.nouveauPatient[champ] = formatted;
                }
            },
            formatRangGem(champ) {
                let val = "";
                if (champ == 'CodeRegime' || champ == 'RangGem') {
                    val = this.patientModifie[champ];

                    if (/^\d$/.test(val)) {
                        this.patientModifie[champ] = "0" + val;
                    }
                    else if (/^\d{2,}$/.test(val)) {
                        this.patientModifie[champ] = val.slice(0, 2);
                    }
                } else {
                    if (champ == 'Regime') {
                        champ = 'codeRegime';
                    }

                    if (champ == 'Gem') {
                        champ = 'rangGem';
                    }

                    val = this.nouveauPatient[champ];

                    if (/^\d$/.test(val)) {
                        this.nouveauPatient[champ] = "0" + val;
                    }
                    else if (/^\d{2,}$/.test(val)) {
                        this.nouveauPatient[champ] = val.slice(0, 2);
                    }
                }
            },
            formatDate(date) {

                let val = "";

                if (this.modificationActive) {
                    val = this.patientModifie[date].trim();
                    if (val === "") {
                        if (date == 'DateDebutMut' || date == 'DateFinMut') {
                            this.dateErrorMessage = "";
                        } else {
                            this.ajoutErrorMessage = "";
                        }
                        return;
                    }
                } else {
                    this.ajoutErrorMessage = "";
                    val = this.nouveauPatient.date.trim();
                }

                let jour, mois, annee;

                if (/^\d{6}$/.test(val)) {
                    // Format JJMMYY
                    jour = parseInt(val.slice(0, 2), 10);
                    mois = parseInt(val.slice(2, 4), 10);
                    annee = parseInt(val.slice(4, 6), 10);
                    annee = annee > 50 ? 1900 + annee : 2000 + annee;
                } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(val)) {
                    // Format JJ/MM/AA
                    [jour, mois, annee] = val.split('/').map(Number);
                    annee = annee > 50 ? 1900 + annee : 2000 + annee;
                } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
                    // Format JJ/MM/AAAA
                    [jour, mois, annee] = val.split('/').map(Number);
                } else {
                    if (this.modificationActive) {
                        if (date == 'DateDebutMut' || date == 'DateFinMut') {
                            this.dateErrorMessage = "Format de date invalide. Utilisez JJ/MM/AA, JJ/MM/AAAA ou JJMMYY.";
                        } else {
                            this.ajoutErrorMessage = "Format de date invalide. Utilisez JJ/MM/AA, JJ/MM/AAAA ou JJMMYY.";
                        }
                        this.patientModifie[date] = "";
                    } else {
                        this.nouveauPatient.date = "";
                        this.ajoutErrorMessage = "Format de date invalide. Utilisez JJ/MM/AA, JJ/MM/AAAA ou JJMMYY.";
                    }
                    return;
                }

                // Vérifications de validité
                if (jour < 1 || jour > 31 || mois < 1 || mois > 12 || annee < 1900) {
                    if (this.modificationActive) {
                        if (date == 'DateDebutMut' || date == 'DateFinMut') {
                            this.dateErrorMessage = "Date invalide : jour, mois ou année incorrect.";
                        } else {
                            this.ajoutErrorMessage = "Date invalide : jour, mois ou année incorrect.";
                        }
                        this.patientModifie[date] = "";
                    } else {
                        this.ajoutErrorMessage = "Date invalide : jour, mois ou année incorrect.";
                        this.nouveauPatient.date = "";
                    }
                    return;
                }

                const dateSaisie = new Date(annee, mois - 1, jour);
                const aujourdHui = new Date();

                if (dateSaisie > aujourdHui) {
                    if (this.modificationActive) {
                        if (date == 'DateDebutMut' || date == 'DateFinMut') {
                            this.dateErrorMessage = "La date ne peut pas être dans le futur.";
                        } else {
                            this.ajoutErrorMessage = "La date ne peut pas être dans le futur.";
                        }
                        this.patientModifie[date] = "";
                    } else {
                        this.ajoutErrorMessage = "La date ne peut pas être dans le futur.";
                        this.nouveauPatient.date = "";
                    }
                    return;
                }
                this.ajoutErrorMessage = "";
                this.dateErrorMessage = "";
                // Mise en forme finale
                if (this.modificationActive) {
                    this.patientModifie[date] = `${String(jour).padStart(2, '0')}/${String(mois).padStart(2, '0')}/${annee}`;
                } else {
                    this.nouveauPatient.date = `${String(jour).padStart(2, '0')}/${String(mois).padStart(2, '0')}/${annee}`;
                }
            },
            filterDateInput(date) {
                if (this.modificationActive) {
                    this.patientModifie[date] = this.patientModifie[date].replace(/[^\d\/]/g, '');
                } else {
                    this.nouveauPatient.date = this.nouveauPatient.date.replace(/[^\d\/]/g, '');
                }
            },
            onlyDigits(event) {
                const key = event.key;
                if (!/[\d]/.test(key)) {
                    event.preventDefault();
                }
            },
            formatDateISOToFR(dateStr) {
                const [year, month, day] = dateStr.split("-");
                return `${day}/${month}/${year}`;
            },
            getCleNir(nir) {
                if (!nir) return "";

                let nirAssure = nir.replace(/\s+/g, "").toUpperCase();

                nirAssure = nirAssure.replace("2A", "19");
                nirAssure = nirAssure.replace("2B", "18");

                if (/^\d+$/.test(nirAssure)) {
                    const intTest = BigInt(nirAssure);
                    const cleNir = 97n - (intTest % 97n);
                    return cleNir.toString().padStart(2, '0');
                } else {
                    return "";
                }
            },
            isNirEtCleValide(nir, cle) {
                if (typeof cle !== 'string' || cle.length !== 2) {
                    return false;
                }

                if (!/^\d{2}$/.test(cle)) {
                    return false;
                }

                const cleTheorique = this.getCleNir(nir);

                if (cleTheorique.length === 0) {
                    return false;
                }

                return parseInt(cle, 10) === parseInt(cleTheorique, 10);
            },
            completionAutomatique() {
                console.log("infos carte : ", this.infosCarteVitale);
                this.nouveauPatient.numAssu = this.infosCarteVitale[0].NIRAssure;
                this.nouveauPatient.cle = this.infosCarteVitale[0].CleAssure;
                this.nouveauPatient.nir = this.infosCarteVitale[0].NIR;
                this.nouveauPatient.cleNir = this.infosCarteVitale[0].Cle;
                this.nouveauPatient.date = this.formatDateISOToFR(this.infosCarteVitale[0].DateNaissance);
                this.nouveauPatient.rangGem = this.infosCarteVitale[0].RangNaissance;
                this.nouveauPatient.codeCaisse = this.infosCarteVitale[0].CodeCaisse;
                this.nouveauPatient.codeCentre = this.infosCarteVitale[0].CodeCentre;
                this.nouveauPatient.codeRegime = this.infosCarteVitale[0].CodeRegime;

                this.formatDate();
                this.formatNumAssure('numAssu');
                this.formatNumAssure('nir');
                this.formatRangGem('rangGem');
                this.formatRangGem('codeRegime');
            }
        },
        mounted() {
            //var critere = "*";
            //var appliLance = "transCam";
            //Patient.getAllPatientsWithApp(appliLance)
            //    .then(response => {
            //        console.log(response);
            //        this.lesPatients = response;
            //        this.assure = response[0];
            //    }); 

            this.fetchClaims();

            // v-dialog : plus de pre-init aria/inert ni de handler 'hidden.bs.modal' Bootstrap.
            if (this.$route.query.setPatient) {
                this.selectPatient(JSON.parse(this.$route.query.setPatient), 0);
            }
        },

        beforeUnmount() {
            clearTimeout(this.rechercheTimer);
            // v-dialog (Vuetify) gere lui-meme overlay et scroll-lock : plus de nettoyage backdrop.
        }

        //props: ["lesPatients"]

    });
</script>

<!--<div class="container-Patient">
    <div class="container-recherche-patient">
        <h2>Critère de recherche</h2>
        <label>
            <input type="text" name="name" value="" />
            <input id="recherche-bar" class="width-cent" v-model="critereRecherchePatientTransCam" v-on:keyup="chercher()" />
            <button @click="chercher()">Rechercher</button>
        </label>
        <div class="result-recherche">-->
<!--<Grid @setModifEnTempsReel="setModifEnTempsReel" v-bind:lesPatients="lesPatients" @setPatientCourant="setPatientCourant" @setLesPatients="setLesPatients" />-->
<!--<table>
    <thead>-->
<!--<tr class="teteTableau">
    <th class="row-table" v-on:click="commencerLeTrie(uneCle)" v-for="uneCle in lesCles">{{uneCle}}</th>
</tr>-->
<!--</thead>
<tbody>-->
<!--<tr class="row-table" v-for="unPatient in lesPatientsTries" v-bind:key="unPatient.Key" v-on:click="afficherPatientCourant(unPatient)">
    <td data-label="Date de Naissance">{{unPatient.DateNaissance}} AA</td>
    <td data-label="Nom">{{unPatient.Nom}} AA</td>
    <td data-label="Prénom">{{unPatient.Prenom}} AA</td>
</tr>-->
<!--<tr v-for="unPatient in lesPatients" v-bind:key="unPatient.Identifiant" @click="setPatientCourant(unPatient)">
                        <td data-label="Date de Naissance">{{unPatient.DateNaissance}} AA</td>
                        <td data-label="Nom">{{unPatient.Nom}} AA</td>
                        <td data-label="Prénom">{{unPatient.Prenom}} AA</td>
                    </tr>

                </tbody>
            </table>
        </div>
        <label><button>Nouveau</button> <button>Modifier</button> <button>Supprimer</button></label>
    </div>

    <div class="container-formulaire">
        <div class="container-Assuré">
            <h2>Assuré(e)</h2>
            <div class="component-Assuré-patient-1">
                <label>Nom<input type="text" name="name" v-model="assure.Nom" /></label>
                <label>Prénom<input type="text" name="name" v-model="assure.Prenom" /></label>
            </div>
            <div class="component-Assuré-patient-2">
                <label>Adresse<input type="text" name="name" v-model="assure.Adresse" /></label>
                <label>C.P. <input type="text" name="name" v-model="assure.CodePostal" /> </label>
                <label>Ville  <input type="text" name="name" v-model="assure.Ville" /></label>
            </div>
            <div class="component-Assuré-patient-3">
                <label>Situation <input type="text" name="name" value="" />  </label>
                <label>N° d'assuré(e) <input type="text" name="name" value="" /> </label>

                <label>
                    Clé <input type="text" name="name" value="" />
                    <select v-model="selectedNirFictif">
                        <option value="">Nir Fictif</option>
                        <option v-for="NirFictif in lesNirFictif" placeholder :value="NirFictif">{{ NirFictif }}</option>
                    </select>
                </label>
            </div>
            <div class="component-Assuré-patient-4">
                <label>Code Régime<input type="text" name="name" value="" /> </label>
                <label>Caisse Gestionnaire<input type="text" name="name" value="" /></label>
                <label>Code Gestion<input type="text" name="name" value="" /> </label>
                <label>Centre Gestionnaire<input type="text" name="name" value="" /></label>
            </div>
        </div>

        <div class="container-Complementaire">
            <h2>Complémentaire / Mutuelle</h2>

            <div class="component-Complémentaire-patient-1">
                <label>Mutuelle<input type="checkbox" name="name" value="" /></label>
                <label>Début<input type="text" name="name" value="" /></label>
                <label>Fin<input type="text" name="name" value="" /></label>
            </div>

            <div class="component-Complémentaire-patient-2">
                <label>Identification<input type="text" name="name" value="" /></label>
                <label>Garantie<input type="text" name="name" value="" /></label>
            </div>

            <div class="component-Complémentaire-patient-3">
                <label>Numéro AMC<input type="text" name="name" value="" /></label>
                <label>N° ass AMC<input type="text" name="name" value="" /></label>
            </div>

            <div class="component-Complémentaire-patient-4">
                <label>Domaine<input type="text" name="name" value="" /></label>
                <label>No adhérent<input type="text" name="name" value="" /></label>
            </div>

            <div class="component-Complémentaire-patient-5">
                <label>Routage<input type="text" name="name" value="" /></label>
                <label>Trt<input type="text" name="name" value="" /></label>
                <label>Hôte<input type="text" name="name" value="" /></label>
                <label>Aiguillage STS<input type="text" name="name" value="" /></label>
            </div>

        </div>

        <div class="container-Patient-formulaire">
            <h2>Patient</h2>
            <label>N°Dossier<input type="text" name="name" v-model="patientCourant.NumDossier" /></label>
            <label>Créer le<input type="text" name="name" v-model="patientCourant.DateCreation" /></label>
            <label>Nom<input type="text" name="name" value="" /></label>

            <label>Nom usuel<input type="text" name="name" v-model="patientCourant.Nom" /></label>
            <label>Prénom<input type="text" name="name" v-model="patientCourant.Prenom" /></label>
            <label>Adresse<input type="text" name="name" v-model="patientCourant.Adresse" /></label>
            <label>C.P.<input type="text" name="name" v-model="patientCourant.CodePostale" /></label>
            <label>Ville<input type="text" name="name" v-model="patientCourant.CodePostale" /></label>

            <label>Date de Naissance<input type="text" name="name" value="" /></label>
            <label>Lien avec l'assuré(e)<input type="text" name="name" value="" /></label>
            <label>Qualité bénefice<input type="text" name="name" value="" /></label>
            <label>Type Immatriculation<input type="text" name="name" value="" /></label>
            <label>R-G<input type="text" name="name" value="" /> Conv référent<input type="checkbox" name="name" value="" />
            Droit jusqu'au<input type="text" name="name" value="" /></label>
            <label>100% jusqu'au :<input type="text" name="name" value="" /></label>

            <label>
                Libellé VITALE
                <select v-model="selectedLibellé">
                    <option v-for="libellé in libellés" :value="libellé">{{ libellé }}</option>
                </select>
            </label>


        </div>
        <div class="bouton-formulaire">
            <button>Défaut</button>
            <button v-on:click="fse">OK</button>
            <button>Annuler</button>

        </div>
    </div>

</div>-->
<!--/*.container-Patient {
        color: black;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .container-recherche-patient h2 {
        margin-top: 10px;
        color: white;
    }

    .container-recherche-patient {
        background: pink;
        border-radius: 30px;
        margin: 10px;
    }

    .result-recherche {
        background: white;
        height: 100%;
        width: 95%;
        margin: auto;
    }

    .container-recherche-patient h2 {
        text-align: center;
    }

    .container-recherche-patient {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

        .container-recherche-patient label {
            display: flex;
            justify-content: space-between;
            margin: 10px;
        }

    button {
        padding: 8px 16px;
        background-color: #4CAF50;
        color: white;
        border: none;
        border-radius: 5px;
        font-size: 14px;
        cursor: pointer;
        margin-right: 10px;
    }

        button:hover {
            background-color: #45a049;
        }

    .container-recherche-patient input[type="text"] {
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 14px;
        margin-right: 10px;
    }

        .container-recherche-patient input[type="text"]:focus {
            outline: none;
            border-color: #4CAF50;*/
            /* Autres styles */
        /*}


    .container-Assuré label {
        white-space: nowrap;
        display: flex;
        flex-wrap: wrap;
    }



        .container-Assuré label input {
            width: 100px;
            height: 23px;
        }

    .container-Assuré {
        font-family: Arial;
        font-size: 18px;
        color: black;
        border: 1px solid red;
        background-color: #ffe3e3;
        padding: 20px;
        width: 800px;
    }

    .component-Assuré-patient-1 {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        grid-gap: 10px;
    }

        .component-Assuré-patient-1 label input*/ /*input:500px*/ /*{
            width: 255px;
            margin-left: 21px;
        }

    .component-Assuré-patient-2 {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        grid-gap: 10px;
    }

        .component-Assuré-patient-2 label:nth-child(2) input {
            width: 70px;
        }

        .component-Assuré-patient-2 label:nth-child(3) input {
            width: 165px;
        }

        .component-Assuré-patient-2 label:nth-child(1) input {
            width: 250px;
        }



    .component-Assuré-patient-3 label:nth-child(3) input {
        width: 58.25px;
        margin-right: 1px;
    }

    .component-Assuré-patient-3 label:nth-child(2) input {
        width: 180px;
    }

    .component-Assuré-patient-3 {*/ /*input:330px*/
        /*margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        grid-gap: 10px;
    }

    .component-Assuré-patient-4 {
        margin-top: 10px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        padding: 10px;
        border: 2px solid #e6e6e6;
        border-radius: 5px;
        background-image: linear-gradient(to right, #ff96b4, #ff7290);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        font-family: Arial, sans-serif;
        color: white;
    }

        .component-Assuré-patient-4 label input {
            margin-left: 10px;
            margin-right: 10px;
        }

    input {
        border: none;
        border-radius: 15px;
    }

    h2 {
        text-align: center;
    }

    .component-Assuré-patient-4 label:nth-child(1) input {
        width: 50px;
    }

    .component-Assuré-patient-4 label:nth-child(3) input {
        width: 50px;
    }

    .component-Assuré-patient-1 label:nth-child(1) input {
        margin-left: 42px;
    }

    .component-Assuré-patient-2 label input {
        margin-left: 15px;
    }

    .component-Assuré-patient-3 label input {
        margin-left: 10px;
    }

    .component-Assuré-patient-3 label:nth-child(1) input {
        width: 180px;
    }



    .container-Complementaire {
        color: black;
        font-family: Arial;
        font-size: 18px;
        border: 1px solid red;
        background-color: #ffe3e3;
        padding: 20px;
        width: 800px;
        margin-top: 5px;
        white-space: nowrap;
    }

    .component-Complémentaire-patient-1 {
        display: flex;
        flex-direction: row;
    }


    .container-Complementaire h2 {
        margin-bottom: 30px;
    }


    .container-Complementaire label input {
        width: 150px;
        height: 23px;
        margin-left: 10px;
        margin-right: 10px;
    }

    .container-Patient-formulaire {
        color: black;
        font-family: Arial;
        font-size: 18px;
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 10px;
        border: 1px solid red;
        background-color: #ffe3e3;
        padding: 20px;
        width: 800px;
        margin-top: 5px;
    }

        .container-Patient-formulaire label:nth-child(14) {
            flex-wrap: unset;
            white-space: nowrap;
        }

            .container-Patient-formulaire label:nth-child(14) input {
                width: 100%;
                margin-left: 10px;
                margin-right: 10px;
            }

        .container-Patient-formulaire label {
            display: flex;
            flex-wrap: wrap;
        }

            .container-Patient-formulaire label input {
                width: 100%;
                height: 23px;
            }

        .container-Patient-formulaire select {
            width: 100%;
            background-color: white;
            border: 1px solid #ccc;
            border-radius: 5px;
            padding: 8px;
            font-size: 14px;
        }

    .container-Assuré select {
        background-color: white;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 14px;
        height: 23px;
    }*/
    /*






    .bouton-formulaire {
        display: flex;
        justify-content: center;
        align-items: center;
        margin:10px;
    }


    @media screen and (max-width: 800px) {
    }
>>>>>>> d95c223c849610e6208da062cc17fc39c96b7dee*/-->
